/**
 * Treatment-related constants
 * Based on API response format
 */

export enum TreatmentBrand {
    ElitKlinik = "ElitKlinik",
    YesSmile = "YesSmile",
    Rehinomedica = "Rehinomedica",
    Elithair = "Elithair",
}

export enum TreatmentCategory {
    Teeth = "Teeth",
    Face = "Face",
    Body = "Body",
    Hair = "Hair",
}

// Array of available brands for UI components
export const AVAILABLE_BRANDS = Object.values(TreatmentBrand) as readonly string[];

// Array of available categories for UI components
export const AVAILABLE_CATEGORIES = Object.values(TreatmentCategory) as readonly string[];
